import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "console"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "args-head" }
const _hoisted_6 = {
  key: 1,
  class: "empty"
}
const _hoisted_7 = {
  key: 2,
  class: "fields"
}
const _hoisted_8 = {
  key: 0,
  class: "req"
}
const _hoisted_9 = {
  key: 0,
  class: "description"
}
const _hoisted_10 = { class: "actions" }
const _hoisted_11 = {
  key: 1,
  class: "panel error"
}
const _hoisted_12 = {
  key: 2,
  class: "result"
}
const _hoisted_13 = { class: "result-head" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  class: "panel"
}
const _hoisted_17 = {
  key: 1,
  class: "panel error"
}
const _hoisted_18 = {
  key: 2,
  class: "panel"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Switch = _resolveComponent("Switch")
  const _component_TextArea = _resolveComponent("TextArea")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_el_input_tag = _resolveComponent("el-input-tag")
  const _component_Input = _resolveComponent("Input")
  const _component_Footnote = _resolveComponent("Footnote")
  const _component_Button = _resolveComponent("Button")
  const _component_Copy = _resolveComponent("Copy")
  const _component_ObjectViewer = _resolveComponent("ObjectViewer")
  const _component_SettingsFrame = _resolveComponent("SettingsFrame")

  return (_openBlock(), _createBlock(_component_SettingsFrame, {
    class: "test-tools",
    title: "Test Tools",
    description: "Run an agent tool with arguments and inspect the raw result"
  }, {
    default: _withCtx(() => [
      (!$data.tools)
        ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Loading tools...")
            ])),
            _: 1 /* STABLE */
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[5] || (_cache[5] = _createElementVNode("label", null, "Tool", -1 /* HOISTED */)),
                _createVNode(_component_Dropdown, {
                  modelValue: $data.tool,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.tool) = $event)),
                  items: $options.tool_items,
                  placeholder: "Select tool",
                  required: "",
                  disabled: $data.running
                }, null, 8 /* PROPS */, ["modelValue", "items", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[6] || (_cache[6] = _createElementVNode("label", null, "Run as", -1 /* HOISTED */)),
                _createVNode(_component_Dropdown, {
                  modelValue: $data.user_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.user_id) = $event)),
                  items: $options.user_items,
                  placeholder: "Run as me",
                  disabled: $data.running
                }, null, 8 /* PROPS */, ["modelValue", "items", "disabled"])
              ])
            ]),
            ($options.current)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label" }, "Arguments", -1 /* HOISTED */)),
                    _createVNode(_component_Switch, {
                      modelValue: $data.raw,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.raw) = $event)),
                      label: "Raw JSON",
                      onChange: $options.onRawToggle
                    }, null, 8 /* PROPS */, ["modelValue", "onChange"])
                  ]),
                  ($data.raw)
                    ? (_openBlock(), _createBlock(_component_TextArea, {
                        key: 0,
                        modelValue: $data.raw_text,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.raw_text) = $event)),
                        type: "textarea-json",
                        rows: 12,
                        counter: false,
                        error: $data.raw_error,
                        validator: () => !$data.raw_error,
                        class: "raw"
                      }, null, 8 /* PROPS */, ["modelValue", "error", "validator"]))
                    : (!$options.fields.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, "This tool has no inputs"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.fields, (field) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `${$data.tool}-${field.name}`,
                              class: "field"
                            }, [
                              _createElementVNode("label", null, [
                                _createTextVNode(_toDisplayString(field.name), 1 /* TEXT */),
                                (field.required)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "*"))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              (field.description)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(field.description), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              (field.kind === 'enum')
                                ? (_openBlock(), _createBlock(_component_Dropdown, {
                                    key: 1,
                                    modelValue: $data.form[field.name],
                                    "onUpdate:modelValue": $event => (($data.form[field.name]) = $event),
                                    items: field.required ? field.items : [{value: '', title: '—'}, ...field.items],
                                    required: field.required,
                                    placeholder: "Select value"
                                  }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "items", "required"]))
                                : (field.kind === 'multienum')
                                  ? (_openBlock(), _createBlock(_component_Multiselect, {
                                      key: 2,
                                      modelValue: $data.form[field.name],
                                      "onUpdate:modelValue": $event => (($data.form[field.name]) = $event),
                                      items: field.items,
                                      required: field.required,
                                      placeholder: "Select values"
                                    }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "items", "required"]))
                                  : (field.kind === 'tags')
                                    ? (_openBlock(), _createBlock(_component_el_input_tag, {
                                        key: 3,
                                        modelValue: $data.form[field.name],
                                        "onUpdate:modelValue": $event => (($data.form[field.name]) = $event),
                                        max: field.max_items,
                                        placeholder: "Type and press Enter",
                                        class: "tags"
                                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "max"]))
                                    : (field.kind === 'textarea')
                                      ? (_openBlock(), _createBlock(_component_TextArea, {
                                          key: 4,
                                          modelValue: $data.form[field.name],
                                          "onUpdate:modelValue": $event => (($data.form[field.name]) = $event),
                                          rows: 5,
                                          counter: false,
                                          required: field.required
                                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "required"]))
                                      : (_openBlock(), _createBlock(_component_Input, {
                                          key: 5,
                                          modelValue: $data.form[field.name],
                                          "onUpdate:modelValue": $event => (($data.form[field.name]) = $event),
                                          type: field.kind === 'uuid' ? 'text' : field.kind,
                                          required: field.required,
                                          validator: field.kind === 'uuid' ? v => !$options.fieldError(field, v) || 'Must be a valid UUID' : undefined,
                                          spellcheck: false
                                        }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "type", "required", "validator"])),
                              (['multienum', 'tags'].includes(field.kind) && $options.errors[field.name])
                                ? (_openBlock(), _createBlock(_component_Footnote, {
                                    key: 6,
                                    type: "error"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($options.errors[field.name]), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                  }, 1024 /* DYNAMIC_SLOTS */))
                                : _createCommentVNode("v-if", true)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_Button, {
                      primary: "",
                      small: "",
                      loading: $data.running,
                      disabled: !$options.can_run,
                      onClick: $options.run
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode("Run")
                      ])),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["loading", "disabled", "onClick"])
                  ])
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            ($data.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($data.error), 1 /* TEXT */))
              : _createCommentVNode("v-if", true),
            ($data.task)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", null, [
                      _cache[9] || (_cache[9] = _createTextVNode("Status: ")),
                      _createElementVNode("b", {
                        class: _normalizeClass($data.task.status)
                      }, _toDisplayString($data.task.status), 3 /* TEXT, CLASS */)
                    ]),
                    ($data.task.elapsed)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Elapsed: " + _toDisplayString($options.elapsedSeconds($data.task.elapsed).toFixed(2)) + "s", 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    ($options.is_array)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Items: " + _toDisplayString($data.task.result.output.length), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    ($options.has_output)
                      ? (_openBlock(), _createBlock(_component_Copy, {
                          key: 2,
                          class: "copy",
                          onCopy: $options.copyOutput
                        }, null, 8 /* PROPS */, ["onCopy"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  ($data.timed_out)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Still running, check later (task " + _toDisplayString($data.task.id) + ")", 1 /* TEXT */))
                    : ($data.task.status === 'failed')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($data.task.error?.text || 'Task failed'), 1 /* TEXT */))
                      : ($data.task.status === 'completed' && $data.task.result?.no_content)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Tool returned no results"))
                        : ($options.has_output)
                          ? (_openBlock(), _createBlock(_component_ObjectViewer, {
                              key: 3,
                              class: "output",
                              "root-name": "result",
                              object: $data.task.result
                            }, null, 8 /* PROPS */, ["object"]))
                          : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ]))
    ]),
    _: 1 /* STABLE */
  }))
}